import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

const diagnosticClusterBase: Omit<
    SensorClusterConfig<Record<string, never>>,
    "generateSensorElements" | "modelName" | "friendlyName" | "friendlyShortName"
> = {
    communicationMode: SensorPortCommunicationMode.DIGITAL,
    requiredSubChannels: [],
    optionalSubChannels: [],
    isPermanentlyAttached: true,
    parameterConfigs: {},
    manufacturerName: "Verdi",
};

export const genericDiagnosticClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    CrashCount: {
        ...diagnosticClusterBase,
        modelName: "Crash Count",
        friendlyName: "Crash Count",
        friendlyShortName: "Crashes",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCount",
                parameters: {},
                legalConvertedRange: [0, null],
                subChannel: 0,
            },
        ],
    },

    ResetCount: {
        ...diagnosticClusterBase,
        modelName: "Reset Count",
        friendlyName: "Reset Count",
        friendlyShortName: "Resets",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCount",
                parameters: {},
                legalConvertedRange: [0, null],
                subChannel: 0,
            },
        ],
    },

    ValveState: {
        ...diagnosticClusterBase,
        modelName: "Valve State",
        friendlyName: "Valve State",
        friendlyShortName: "Valve",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "valveState",
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
        ],
    },
};
